// eslint-disable-next-line
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Il client fa login o si registra con google
// Il server reindirizza a widget di google
// Google ritorna al server alla route /api/auth/google/callback
// Il server chiama la passport strategy google e ritorna lo user profile e un token che non usiamo
// Usiamo il profile per aggiornare il profilo utente o crearne uno nuovo
// Rimandiamo il client alla route /profile?jwt-token=TOKEN
// Questo componente preleva il token dall'url e lo salva in localStorage
const OAuthCallbackHandler = () => {
  const location = useLocation();
  const { setToken } = useAuth();

  useEffect(() => {
    // console.log('OAuthCallbackHandler');
    const urlParams = new URLSearchParams(location.search);
    const tokenFromUrl = urlParams.get('jwt-token');
    
    if (tokenFromUrl) {
        // console.log('********** OAuthCallbackHandler', tokenFromUrl);
      // Token from URL, authenticate user
      localStorage.setItem('token', tokenFromUrl);
      
      // Clean URL by removing token parameter
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
      
      // Set token in context to trigger authentication
    //   console.log('OAuthCallbackHandler', tokenFromUrl);
      setToken(tokenFromUrl);
      
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null; // This component doesn't render anything
};

export default OAuthCallbackHandler;
